'use strict';

import $ from 'jquery';
export const element = $;
